import { styled } from '@mui/material/styles';

export const DivStyled = styled('div', {
  name: 'DivStyled',
})(({ theme }) => ({
  backgroundColor: theme.palette.primary.light,
  padding: theme.spacing(2),
  paddingTop: 0,
  borderRadius: theme.spacing(1),
}));
